export default "__VITE_ASSET__CqBtUhaV__"